const isDate = (value) => {
  if (!value) return

  const params = value.split("/")
  const year = parseInt(params[2], 10)
  const month = parseInt(params[1], 10)
  const day = parseInt(params[0], 10)

  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  const currentDay = currentDate.getDate()
  const currentMonth = currentDate.getMonth() + 1

  if (
    month > 12 ||
    day > 31 ||
    year > currentYear ||
    year < 1900 ||
    (year >= currentYear && month > currentMonth) ||
    (year >= currentYear && month === currentMonth && day > currentDay)
  ) {
    return false
  }

  const reference = new Date(year, month - 1, day)
  const refYear = reference.getFullYear()
  const refDay = reference.getDate()
  const refMonth = reference.getMonth() + 1

  if (refYear !== year || refMonth !== month || refDay !== day) {
    return false
  }

  return true
}

module.exports = isDate
